// Auto-generated from MessageAudienceKindEnum

export const messageAudienceKind = {
  projectMembers: 'projectMembers',
  function: 'function',
  domainUser: 'domainUser',
  taskMembers: 'taskMembers',
}

export type TMessageAudienceKind = (typeof messageAudienceKind)[keyof typeof messageAudienceKind];
